module.exports = __webpack_public_path__ + "static/media/water-pipe.72321d25.png";